import { useEffect } from 'react';

import {
  getMachinePreferencesFromUrl,
  setMachinePreferencesInLocalStorage,
} from 'features/machine-preferences/helpers';
import { Mode } from 'features/multi-mode/enums';

export const useMachinePreferences = (mode: Mode) => {
  useEffect(() => {
    const machinePreferences = getMachinePreferencesFromUrl();
    const hasMachinePreferencesInUrl =
      machinePreferences.machineId !== null ||
      machinePreferences.stationNumber !== null ||
      machinePreferences.callCenterCode !== null;

    // Preserve previously captured machine preferences across auth callback
    // redirects that strip query params from the URL
    if (!hasMachinePreferencesInUrl) {
      return;
    }

    switch (mode) {
      case Mode.VRI:
        setMachinePreferencesInLocalStorage({
          machineId: machinePreferences.machineId,
          stationNumber: machinePreferences.stationNumber,
        });
        return;
      case Mode.VRS:
        setMachinePreferencesInLocalStorage(machinePreferences);
        return;
      default: {
        const exhaustive: never = mode;
        return exhaustive;
      }
    }
  }, [mode]);
};
